import dayjs from 'dayjs';
import { Flow } from 'types';

export const formatDeliveryModeAfterText = ({
  trigger,
  deliveryMode,
}: {
  trigger: Flow['trigger'] | null;
  deliveryMode: Flow['deliveryMode'];
}): string => {
  if (trigger && trigger == 'Missing Member') {
    return ' after the last check-in';
  } else if (trigger && trigger == 'Check-ins completed') {
    return ' check-ins are completed';
  } else if (trigger && trigger == 'Unsigned document reminder') {
    return ' after the document is sent';
  } else if (trigger && trigger == 'Late Cancel') {
    return ' after the late cancel';
  } else if (trigger && trigger == 'No Show') {
    return ' after the no show';
  } else if (deliveryMode === 'Delayed') {
    return ' after the event';
  } else if (deliveryMode === 'Reminder') {
    return ' before the event';
  } else {
    return '';
  }
};

export const formatFlowDeliveryModeText = ({
  trigger,
  timeUnit,
  timeAmount,
  deliveryMode,
  sendAtTime,
  timeFormat,
}: {
  trigger: Flow['trigger'] | null;
  timeUnit: Flow['timeUnit'];
  timeAmount: number | null;
  deliveryMode: Flow['deliveryMode'];
  sendAtTime: string | null;
  timeFormat: string;
}): string => {
  if (trigger && trigger == 'Missing Member' && timeUnit && timeAmount) {
    const deliveryModeText = timeAmount
      .toString()
      .concat(' ')
      .concat(timeUnit.toLowerCase().replace('s', timeAmount > 1 ? 's' : ''))
      .concat(formatDeliveryModeAfterText({ trigger: trigger, deliveryMode: deliveryMode }));
    if (timeUnit === 'Days' && sendAtTime) {
      return deliveryModeText.concat(' at ').concat(dayjs(sendAtTime, 'HH:mm').format(timeFormat));
    }
    return deliveryModeText;
  } else if (trigger && trigger == 'Check-ins completed' && timeAmount) {
    const deliveryModeText = 'After '.concat(
      timeAmount
        .toString()
        .concat(' ')
        .concat(formatDeliveryModeAfterText({ trigger: trigger, deliveryMode: deliveryMode })),
    );
    return deliveryModeText;
  } else if (deliveryMode === 'Immediate') {
    return 'Immediate';
  } else if (timeAmount !== null && timeUnit) {
    if (timeAmount === 0 && timeUnit === 'Days') {
      return 'Same Day at '.concat(dayjs(sendAtTime, 'HH:mm').format(timeFormat));
    }

    const deliveryModeText = timeAmount
      .toString()
      .concat(' ')
      .concat(timeUnit.toLowerCase().replace('s', timeAmount > 1 ? 's' : ''))
      .concat(formatDeliveryModeAfterText({ trigger: trigger, deliveryMode: deliveryMode }));

    if (timeUnit === 'Days' && sendAtTime) {
      return deliveryModeText.concat(' at ').concat(dayjs(sendAtTime, 'HH:mm').format(timeFormat));
    }
    return deliveryModeText;
  }
  return '+ wait';
};
